// Gallery data for each section
// Updated with actual local images

export const galleryData = {
  hello: [
    {
      src: '/images/galleries/hello/marco.demarco.jpg',
      alt: 'Marco de Marco',
      caption: 'Ciao'
    }
  ],

  apple: [
    {
      src: '/images/galleries/apple/southington_town_seal.png',
      alt: 'Southington Town Seal',
      caption: 'Southington Town Seal'
    },
    {
      src: '/images/galleries/apple/southington_snow.jpg',
      alt: 'Southington in winter',
      caption: 'Southington covered in snow during winter storm Jan 2013'
    },
    {
      src: '/images/galleries/apple/southington_flood.jpg',
      alt: 'Southington flood',
      caption: 'Flooded Dog Park in Southington'
    },
    {
      src: '/images/galleries/apple/southington.jpg',
      alt: 'Southington, CT',
      caption: 'Ciao'
    }
  ],
  
  futbol: [
    {
      src: '/images/galleries/futbol/futbol_marco.jpg',
      alt: 'Marco playing football',
      caption: 'Marco - Memorial Day 2025 Tournament Champions'
    },
    {
      src: '/images/galleries/futbol/futbol_maximiliano.jpg',
      alt: 'Maximiliano playing football',
      caption: 'Maximiliano in training at Day Hill Dome'
    },
    {
      src: '/images/galleries/futbol/futbol_marco_max.jpg',
      alt: 'Marco and Max together',
      caption: 'Marco and Max first Hartford Atheltic Tournament'
    },
    {
      src: '/images/galleries/futbol/futbol_marco_trophy.jpg',
      alt: 'Marco with trophy',
      caption: 'Marco - Winter Fustal Tournament Winner'
    },
    {
      src: '/images/galleries/futbol/futbol_azzurri.jpg',
      alt: 'Azzurri team',
      caption: 'The Azzurri fans'
    }
  ],
  
  rossetti: [
    {
      src: '/images/galleries/rossetti/castel_campagano_right.jpg',
      alt: 'Castel Campagnano',
      caption: 'Castel Campagnano  - Cherub Flute'
    },
    {
      src: '/images/galleries/rossetti/Rossetti_Giuseppe.jpg',
      alt: 'Giuseppe Rossetti',
      caption: 'Giuseppe Rossetti, 1891–1929'
    },
    {
      src: '/images/galleries/rossetti/Brino_Battista-Paolo.jpg',
      alt: 'Battista Paolo Brino',
      caption: 'Battista Paolo Brino'
    },
    {
      src: '/images/galleries/rossetti/Carbone_Francesco.jpg',
      alt: 'Francesco Carbone',
      caption: 'Francesco Carbone'
    },
    {
      src: '/images/galleries/rossetti/Carolina_Mattarazzo-Rossetti.jpg',
      alt: 'Carolina Mattarazzo Rossetti',
      caption: 'Carolina Mattarazzo Rossetti'
    },
    {
      src: '/images/galleries/rossetti/Castaldo_Giovanna-Rossetti.jpg',
      alt: 'Giovanna Castaldo Rossetti',
      caption: 'Giovanna Castaldo Rossetti'
    },
    {
      src: '/images/galleries/rossetti/DelBouno_Guido.jpg',
      alt: 'Guido DelBouno',
      caption: 'Guido DelBouno'
    },
    {
      src: '/images/galleries/rossetti/Giovannina_Rossetti.jpg',
      alt: 'Giovannina Rossetti',
      caption: 'Giovannina Rossetti'
    },
    {
      src: '/images/galleries/rossetti/Marco_Rossetti.jpg',
      alt: 'Marco Rossetti',
      caption: 'Marco Rossetti'
    },
    {
      src: '/images/galleries/rossetti/Pasquale_Rossetti.jpg',
      alt: 'Pasquale Rossetti',
      caption: 'Pasquale Rossetti'
    },
    {
      src: '/images/galleries/rossetti/Picone_Neil.jpg',
      alt: 'Neil Picone',
      caption: 'Neil Picone'
    },
    {
      src: '/images/galleries/rossetti/Testa_Antonio.jpg',
      alt: 'Antonio Testa',
      caption: 'Antonio Testa'
    },
    {
      src: '/images/galleries/rossetti/Thomas_Eric.jpg',
      alt: 'Eric Thomas',
      caption: 'Eric Thomas'
    },
    {
      src: '/images/galleries/rossetti/castel_campagano_left.jpg',
      alt: 'Castel Campagnano',
      caption: 'Castel Campagnano  - Cherub Guitar'
    }
  ],
  
  pane: [
    {
      src: '/images/galleries/pane/san_cocho.jpg',
      alt: 'San Cocho',
      caption: 'Traditional San Cocho - a family recipe'
    }
  ],
  
  wine: [
    {
      src: '/images/galleries/wine/wine_2.jpg',
      alt: 'Cases of Grapes',
      caption: 'Cases & cases of several grape varieties.'
    },
    {
      src: '/images/galleries/wine/wine_1.jpg',
      alt: 'Nonno Marco',
      caption: 'Nonno Marco with the grandkids.'
    },
    {
      src: '/images/galleries/wine/wine_3.jpg',
      alt: 'Nonno & Nonna',
      caption: 'Nonno & Nonna with the grandkids.'
    },
    {
      src: '/images/galleries/wine/wine_4.jpg',
      alt: 'Wine collection',
      caption: 'Family wine colletion'
    }
  ],
  
  jeep: [
    {
      src: '/images/galleries/jeep/jeep_1.jpg',
      alt: 'Jeep adventure',
      caption: 'Jeep ready for adventure'
    }
  ],
  
  genes: [
    // Wine gallery images will be auto-discovered from public/images/galleries/wine/
    {
      src: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=600&fit=crop&auto=format',
      alt: 'Restaurant interior',
      caption: "Gene's restaurant cozy interior"
    },
    {
      src: 'https://images.unsplash.com/photo-1551218808-94e220e084d2?w=800&h=600&fit=crop&auto=format',
      alt: 'Delicious pasta dish',
      caption: 'Signature pasta dish at Gene\'s'
    }
  ],
  wedding: [
    {
      src: '/images/galleries/wedding/marco.demarco.jpg',
      alt: 'Marco de Marco',
      caption: 'Ciao'
    },
    {
      src: '/images/galleries/wedding/GiuseppinaRossetti_PasqualeDeMarco.jpg',
      alt: 'Giuseppina Rossetti & Pasquale DeMarco',
      caption: 'Newlyweds - 1969'
    }
  ],
};

// For local images, use this format instead:
// {
//   src: '/images/galleries/apple/apple1.jpg',
//   alt: 'Description of image',
//   caption: 'Caption for the image'
// }
